import { Box, DialogContent, DialogTitle } from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateExtraInfomation } from "mobx-stores/_models/employee/extra-infomation";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getExtraInfoFormSchema } from "./schema";

export const UpdateExtraInfo = observer(() => {
  const {
    employeeManagement: {
      openUpdateExtraInfo,
      setProp,
      employeeDetail,
      getEmployeeDetail,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
    getControl,
  } = useForm<IUpdateExtraInfomation>(getExtraInfoFormSchema(), {
    bankAccountNumber: employeeDetail?.information?.bankAccountNumber || "",
    birthCertificatePlace:
      employeeDetail?.information?.birthCertificatePlace || "",
    birthDate: employeeDetail?.information?.birthDate || "",
    contact: employeeDetail?.information?.contact || "",
    email: employeeDetail?.information?.email || "",
    employmentStartDate: employeeDetail?.information?.employmentStartDate || "",
    internalRelationship:
      employeeDetail?.information?.internalRelationship || "",
    leavingDate: employeeDetail?.information?.leavingDate || "",
    leavingReason: employeeDetail?.information?.leavingReason || "",
    nationalIDAddress: employeeDetail?.information?.nationalIDAddress || "",
    nationalIDIssueDate: employeeDetail?.information?.nationalIDIssueDate || "",
    nationalIDNumber: employeeDetail?.information?.nationalIDNumber || "",
    note: employeeDetail?.information?.note || "",
    phoneNumber: employeeDetail?.information?.phoneNumber || "",
    recruitmentSourceType: employeeDetail?.information?.recruitmentSourceType,
    registeredHometown: employeeDetail?.information?.registeredHometown || "",
    status: employeeDetail?.information?.status,
  });

  const fetchEmployeeStatus = useCallback(async () => {
    const ctr = getControl("status");
    if (!ctr) return;
    const res = (await ctr.metaData?.searchOptionItemsAsync?.("")) || [];
    if (res) {
      ctr.setProp("optionItems", res);
    }
  }, [getControl]);

  const fetchRecuimentResource = useCallback(async () => {
    const ctr = getControl("recruitmentSourceType");
    if (!ctr) return;
    const res = (await ctr.metaData?.searchOptionItemsAsync?.("")) || [];
    if (res) {
      ctr.setProp("optionItems", res);
    }
  }, [getControl]);

  useEffect(() => {
    fetchEmployeeStatus();
    fetchRecuimentResource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveHandler = useCallback(
    async (data: IUpdateExtraInfomation) => {
      if (!employeeDetail || !employeeDetail?.id) return;
      await employeeBussiness.updateInformation(employeeDetail?.id, data);
      await getEmployeeDetail(employeeDetail?.id);
      setProp("openUpdateExtraInfo", false);
    },
    [getEmployeeDetail, employeeDetail, setProp]
  );

  return (
    <DialogForm
      open={openUpdateExtraInfo}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openUpdateExtraInfo", false)}
      onCancelBtnClicked={() => setProp("openUpdateExtraInfo", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Cập nhật thông tin khác</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
